/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useContext, useEffect, useState } from 'react'


import { Alert, Form } from 'react-bootstrap';
import { useAuth } from '../auth';
import { ADD_PREDICTIVEMAINTENANCE, GET_PRODUCT_LIST_BY_BRAND_TEXT } from '../../../urls';
import { blackboxIdContext } from '../profile/components/contexts/BlackboxIdContext';
import { useLocation } from 'react-router-dom';
import { useDebounce } from '../../../_elfaiotbbx/helpers';
import { GIRIS_YER_TUTUCU, kartGirdisiHatasi } from '../../../_elfaiotbbx/helpers/MaintenanceCard';

interface Product {
    id: string
    brand: string;
    model: string;
}

/**
 * Secilebilir cihaz girisleri. Ilk eleman "sec" yer tutucusu.
 *
 * Eskiden state'ti ve `changeInputList()` secilen girdiyi listeden DUSURUYORDU --
 * ama o fonksiyon yalnizca hic cagrilmayan `saveOneInput` icinden cagriliyordu,
 * yani liste hicbir zaman degismiyordu. Degismeyen bir degerin state olmasi
 * gerekmiyor.
 */
const GIRIS_SECENEKLERI = [GIRIS_YER_TUTUCU, "Input-0", "Input-1", "Input-2", "Input-3", "Input-4",
    "Input-5", "Input-6", "Input-7", "Input-8", "Input-9", "Input-10", "Input-11", "Input-12",
    "Input-13", "Input-14", "Input-15"]

export function AddReperation() {

    const { currentUser, logout } = useAuth()
    const currentBlackBoxId = useContext(blackboxIdContext);
    const location = useLocation();
    const uid = (location.state as { uid?: string })?.uid;
    const [productList, setProductList] = useState<Product[]>([])
    const [searchTerm, setSearchTerm] = useState('');

    const token = currentUser?.token
    const kullaniciId = currentUser?.id

    const [loading, setLoading] = useState(false)
    const [selectedValue, setSelectedValue] = useState('');
    const [description, setDescription] = useState("")
    /** Secilen cihaz girisi, ornek "Input-3". Sunucuya `ioNumber` olarak gidiyor. */
    const [dataType, setDataType] = useState<string>("")

    /**
     * Uyari ARTIK YAZILIYOR.
     *
     * Ekranda bir `<Alert show={showAlert}>` duruyordu ama `setShowAlert`,
     * `setAlertText` ve `setAlertVariant` HIC CAGRILMIYORDU -- yani uyari
     * kalici olarak gizliydi ve varsayilan metni ("Aynı node id'li cihaz
     * eklenemez") kimse gormuyordu. Bu hafta bu kaliba besinci kez rastladim.
     */
    const [alertVariant, setAlertVariant] = useState("danger")
    const [showAlert, setShowAlert] = useState(false)
    const [alertText, setAlertText] = useState("")

    const uyariGoster = (tip: string, metin: string) => {
        setAlertVariant(tip)
        setAlertText(metin)
        setShowAlert(true)
    }

    const createHeader = () => {
        const headers = new Headers();
        headers.append('Content-Type', 'application/json');
        headers.append('Authorization', "" + token?.toString());
        return headers
    }

    const changeDescriptionOnRep = (e) => setDescription(e.target.value)

    const changeDataType = input => {
        setDataType(input.target.value);
    }

    const getCanioInput = () => {
        return GIRIS_SECENEKLERI.map((input, index) => (
            <option key={index} value={input.toString()}>{input}</option>
        ));
    };

    function sendData() {
        const hata = kartGirdisiHatasi(dataType, description, selectedValue)
        if (hata) {
            uyariGoster("danger", hata)
            return
        }

        addPredictivemaintenance({
            "blackboxId": currentBlackBoxId[0],
            "description": description,
            "uid": uid,
            "ioNumber": dataType,
            "ioDeviceId": selectedValue,
        })
    }

    /**
     * Karti kaydeder.
     *
     * Onceden ne `ok`, ne 401, ne `catch` vardi ve sonuc yalnizca
     * `console.log`'a yaziliyordu: kullanici "Değişikleri Kaydet"e basiyor ve
     * kaydin olup olmadigini HIC ogrenemiyordu. Dugmedeki gostergeyi suren
     * `loading` state'i de hic yazilmiyordu, yani spinner asla gorunmuyordu.
     */
    async function addPredictivemaintenance(data: any) {
        setLoading(true)
        try {
            const response = await fetch(ADD_PREDICTIVEMAINTENANCE, {
                method: "POST",
                headers: createHeader(),
                body: JSON.stringify(data)
            })
            if (response.status === 401) { logout(); return }
            if (!response.ok) { throw new Error(`HTTP ${response.status}`) }

            uyariGoster("success", "Kart kaydedildi.")
        } catch (e) {
            console.error("Kart kaydedilemedi:", e)
            uyariGoster("danger", "Kart kaydedilemedi.")
        } finally {
            setLoading(false)
        }
    }

    const handleSelectChange = (event) => {
        setSelectedValue(event.target.value);
        setSearchTerm(event.target.value);
    };

    const debouncedSearchTerm = useDebounce(searchTerm, 500);

    useEffect(() => {
        if (debouncedSearchTerm) {
            fetch(GET_PRODUCT_LIST_BY_BRAND_TEXT + `?searchtext=${debouncedSearchTerm}&userId=${currentUser?.id}`, {
                method: "GET",
                headers: createHeader(),
            })
                .then(response => response.json())
                .then(data => setProductList(data))
                .catch(error => console.error('Error fetching data:', error));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [debouncedSearchTerm])

    const handleInputChange = (event) => {
        setSearchTerm(event.target.value);
        setSelectedValue('');  // Arama yaparken seçimi temizleyin
    };

    return (


        <>

            <div className='card mb-5 mb-xl-10'>
                <div
                    className='card-header border-0 cursor-pointer'
                    role='button'
                    data-bs-toggle='collapse'
                    data-bs-target='#kt_account_profile_details'
                    aria-expanded='true'
                    aria-controls='kt_account_profile_details'
                >
                    <div className='card-title m-0'>
                        <h3 className='fw-bolder m-0'>Bakım yapılandırma</h3>
                    </div>
                </div>
                {kullaniciId !== undefined &&
                    <div id='kt_account_profile_details' className='collapse show'>
                        <form noValidate className='form'>
                            <div className='card-body border-top p-9'>


                                <div className='row mb-6'>
                                    <label className='col-lg-2 col-form-label fw-bold fs-6'>
                                        <span className='required'>Input</span>
                                    </label>

                                    <div className='col-lg-4 fv-row'>
                                        {/* `onChange`, ONCEDEN `onClick`'ti: klavyeyle secim
                                            (Tab + oklar) HIC calismiyordu ve listeyi acip
                                            kapatmak bile isleyiciyi tetikliyordu. Ayni kusuru
                                            Canio sayfasinda 17 acilir listede duzeltmistik. */}
                                        <select
                                            className='form-select form-select-solid form-select-lg fw-bold'
                                            value={dataType}
                                            onChange={(e) => changeDataType(e)}
                                        >
                                            {getCanioInput()}
                                        </select>
                                        <div className='fv-plugins-message-container'>
                                            <div className='fv-help-block'></div>
                                        </div>
                                    </div>

                                </div>

                                <div className='row mb-6'>

                                    <label className='col-lg-2 col-form-label fw-bold fs-6'>
                                        <span className='required'>Açıklama</span>
                                    </label>

                                    <div style={{ maxWidth: "500px", width: "100%", display: "inline-block", }}>
                                        <Form.Control
                                            aria-label="Açıklama"
                                            id="graphicType"
                                            value={description}
                                            onChange={e => changeDescriptionOnRep(e)}
                                        />
                                    </div>
                                </div>

                                <div className='row mb-6'>
                                    <label htmlFor="searchBar">Ara:</label>
                                    <input
                                        type="text"
                                        id="searchBar"
                                        className="form-control"
                                        value={searchTerm}
                                        onChange={handleInputChange}
                                        placeholder="Aramak için bir şeyler yazın..."
                                    />
                                </div >
                                <div >
                                    {productList.length > 0 && (
                                        <select
                                            id="comboBox"
                                            className="form-control mt-2"
                                            value={selectedValue}
                                            onChange={handleSelectChange}
                                            size={5}  // Birden fazla seçeneği göstermek için
                                        >
                                            <option value="">Seçiniz...</option>
                                            {productList.map(item => (
                                                <option key={item.id} value={item.id}>
                                                    {item.brand + " " + item.model}
                                                </option>
                                            ))}
                                        </select>
                                    )}
                                </div>

                            </div>

                            <Alert key={alertVariant} variant={alertVariant} show={showAlert}>
                                {alertText}
                            </Alert>
                            <div className='card-footer d-flex justify-content-end py-6 px-9'>
                                {/* `<a>` degil `<button>`: tiklanabilir gorunen ama hicbir
                                    yere gitmeyen bir baglanti degil. */}
                                <button type='button' className='btn btn-primary' onClick={sendData} disabled={loading}>
                                    {!loading && 'Değişikleri Kaydet'}
                                    {loading && (
                                        <span className='indicator-progress' style={{ display: 'block' }}>
                                            Kaydediliyor…{' '}
                                            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
                                        </span>
                                    )}
                                </button>
                            </div>

                        </form>

                    </div >
                }

            </div >
        </>

    )
}
